import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'iwt-estatecloud-migration-header',
  templateUrl: './migration-header.component.html',
  styleUrls: ['./migration-header.component.scss'],
})
export class MigrationHeaderComponent {}
